(function () {

    'use strict';

    angular.module('asys')
        .component('asysReiterAbschlussHinweise', {
            bindings: {
                angebotModel: '<arahAngebotModel',
                abschlussVm: '<arahVm'
            },
            templateUrl: 'reiter/abschluss/partials/reiterAbschlussHinweise.html',
            controller: ReiterAbschlussHinweiseController,
            controllerAs: 'hinweiseVm'
        });

    ReiterAbschlussHinweiseController.$inject = [
        '$scope',
        '$q',
        '$modal',
        'lodash',
        'AppConfig',
        'AngebotKfzService',
        'BinaryUtilsService',
        'FilecacheService',
        'FormatUtilsService',
        'BasisAngebotService',
        'WaitOverlayService',
        'MiscUtilsService'
    ];

    function ReiterAbschlussHinweiseController($scope, $q, $modal, _, AppConfig, AngebotKfzService, BinaryUtilsService, FilecacheService, FormatUtilsService, BasisAngebotService, WaitOverlayService, MiscUtilsService) {
        var vm = this,
            formulare = {
                tb28: {
                    pdfName: 'SF-Klasse-Anrechnung-{0}.pdf',
                    bezeichnung: 'SF-Klasse Anrechnung Formular'
                },
                rueckwirkenderVertragsbeginn: {
                    pdfName: 'Beginnverlegung-{0}.pdf',
                    bezeichnung: 'Beginnverlegung Formular'
                }
            };

        vm.$onInit = onInit;

        vm.isBlocKErlaubt = isBlocKErlaubt;
        vm.isBlockTB28FormularErlaubt = isBlockTB28FormularErlaubt;
        vm.isBlockRueckwirkenderVertragsbeginnFormularErlaubt = isBlockRueckwirkenderVertragsbeginnFormularErlaubt;
        vm.isBlockThgPraemieErlaubt = isBlockThgPraemieErlaubt;
        vm.formularDrucken = formularDrucken;

        function activate() {
            vm.tb28FormularPdf = null;
            vm.rueckwirkenderVertragsbeginnFormularPdf = null;
            _.set(formulare, 'tb28.pdfName', FormatUtilsService.replace(_.get(formulare, 'tb28.pdfName'), BasisAngebotService.getAngebotsnummer(vm.angebotModel.angebot, true)));
            _.set(formulare, 'rueckwirkenderVertragsbeginn.pdfName', FormatUtilsService.replace(_.get(formulare, 'rueckwirkenderVertragsbeginn.pdfName'), BasisAngebotService.getAngebotsnummer(vm.angebotModel.angebot, true)));

            vm.formulare = formulare;
            vm.thgPraemieLink = AppConfig.APP.urls.thgPraemie;
        }

        function onInit() {
            activate();
        }
        function isBlocKErlaubt() {
            return (
                isBlockTB28FormularErlaubt() ||
                isBlockRueckwirkenderVertragsbeginnFormularErlaubt() ||
                isBlockThgPraemieErlaubt()
            );
        }
        function isBlockTB28FormularErlaubt() {
            return (
                AngebotKfzService.isGevo(vm.angebotModel.angebot, [
                    'KFZ_TRANSFERBESTIMMUNG_28' // '1b'
                ]) ||
                (
                    AngebotKfzService.isGevo(vm.angebotModel.angebot, [
                        'KFZ_VERSICHERERWECHSEL_SELBES_FZG' // '3'
                    ]) &&
                    _.get(vm.angebotModel.angebot, 'rabattuebertragung.vorversicherungAufDritten') === true
                )
            );
        }
        function isBlockRueckwirkenderVertragsbeginnFormularErlaubt() {
            return (
                AngebotKfzService.isRueckwirkenderVertragsbeginnErlaubt(vm.angebotModel)
            );
        }
        function isBlockThgPraemieErlaubt() {
            return (
                vm.thgPraemieLink &&
                _.get(vm.angebotModel.angebot, 'angebotsgegenstandFahrzeug.thgPraemieVorhanden') === true
            );
        }
        function formularDrucken(formularName) {
            var cachedFile,
                bezeichnung = _.get(formulare, formularName + '.bezeichnung'),
                deferred,
                pdfLoadedDeferred,
                modalPdfViewer,
                overlay;

            if (!MiscUtilsService.isPdfjsViewerEnabled()) {
                vm.abschlussVm.isWaitOverlayOpened = true;

                vm.abschlussVm.waitOverlay = {
                    url: AppConfig.ANGEBOT.waitHelperUrl,
                    options: {
                        id: 'wgv',
                        logo: 'wgv_logo.svg',
                        message: AppConfig.MESSAGES.druckenPopup,
                        popupName: bezeichnung,
                        popupWidth: 720,
                        popupHeight: 610,
                        showLoading: true
                    }
                };
            } else {
                deferred = $q.defer();
                pdfLoadedDeferred = $q.defer();

                modalPdfViewer = $modal.open({
                    templateUrl: 'modal/modalPdfViewer.html',
                    windowClass: 'xlarge pdfjs',
                    controller: 'ModalPdfViewerController',
                    controllerAs: 'modalVm',
                    resolve: { /* @ngInject */
                        pdf: [function () {
                            return deferred.promise;
                        }]
                    }
                });

                modalPdfViewer.result.then(function () {
                }).catch(function (error) {
                });

                deferred.resolve(pdfLoadedDeferred);
            }

            AngebotKfzService[formularName + 'FormularDrucken'](vm.angebotModel).then(function (data) {
                if (!MiscUtilsService.isPdfjsViewerEnabled()) {
                    overlay = WaitOverlayService.get();
                }

                BinaryUtilsService.convertBinaryToFile(data.binary, 'pdf').then(function (file) {
                    cachedFile = FilecacheService.addFile({
                        name: _.get(formulare, formularName + '.pdfName'),
                        type: 'report',
                        bezeichnung: bezeichnung,
                        blobUrl: file.blobUrl,
                        blob: file.blob,
                        filename: data.filename
                    });
                    vm[formularName + 'FormularPdf'] = cachedFile;

                    if (!MiscUtilsService.isPdfjsViewerEnabled()) {
                        $scope.$emit('iplusjs:openFile', cachedFile, overlay.popup);
                        WaitOverlayService.close(false);
                    } else {
                        pdfLoadedDeferred.resolve(cachedFile);
                    }
                }).catch(function () {
                    if (!MiscUtilsService.isPdfjsViewerEnabled()) {
                        WaitOverlayService.close();
                    } else if (pdfLoadedDeferred) {
                        pdfLoadedDeferred.reject();
                    }
                });
            }).catch(function (error) {
                if (!MiscUtilsService.isPdfjsViewerEnabled()) {
                    vm.abschlussVm.waitOverlay = null;
                    WaitOverlayService.close();
                } else if (pdfLoadedDeferred) {
                    pdfLoadedDeferred.reject();
                }
            }).finally(function () {
                if (!MiscUtilsService.isPdfjsViewerEnabled()) {
                    vm.abschlussVm.isWaitOverlayOpened = false;
                }
            });
        }
    }

})();
